var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('v-card',{staticClass:"notice-main"},[_c('div',{staticClass:"title"},[_c('i',{staticClass:"fas fa-bullhorn",staticStyle:{"color":"#f59e0b"}}),_c('span',{staticClass:"titleName"},[_vm._v("公告信息")])]),_c('div',{staticClass:"info"},[_c('span',[_vm._v(_vm._s(_vm.$store.state.webSiteInfo.bulletin))])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }